import { inferSuggestionIsCountry, pickSuggestionLabel } from "./autocomplete-label";
import type { AddressResult } from "@/hooks/useAddressAutocomplete";

export type HeaderSearchChoice =
  | { kind: "car"; query: string; make?: string }
  | { kind: "place"; place: AddressResult };

/** Use a real inventory make prefix; the remainder is the model query. */
export function catalogueSearchChoice(text: string, makes: readonly string[]): HeaderSearchChoice {
  const input = text.trim();
  const normalized = input.toLocaleLowerCase();
  const make = [...makes].sort((a, b) => b.length - a.length).find(value =>
    normalized === value.toLocaleLowerCase() || normalized.startsWith(`${value.toLocaleLowerCase()} `));
  return { kind: "car", make, query: make ? input.slice(make.length).trim() : input };
}

/** Change only the chosen discovery dimension; dates and other filters survive. */
export function headerSearchDestination(search: string, choice: HeaderSearchChoice): string {
  const params = new URLSearchParams(search);
  params.delete("page");
  if (choice.kind === "car") {
    params.delete("make");
    params.delete("q");
    if (choice.make) params.set("make", choice.make);
    if (choice.query.trim()) params.set("q", choice.query.trim());
  } else {
    params.set("location", pickSuggestionLabel(choice.place));
    params.delete("location_country");
    if (inferSuggestionIsCountry(choice.place)) params.set("location_country", choice.place.countryCode);
    for (const key of ["bounds_north", "bounds_south", "bounds_east", "bounds_west"]) params.delete(key);
  }
  return `/search?${params.toString()}`;
}